import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=1b5665d5"
import script from "./radio-group.vue?vue&type=script&lang=js"
export * from "./radio-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports